import React from 'react';
import { NotFound } from 'views/error/404';

const Signup = React.lazy(() => import('views/auth/signup/account').then(m => ({ default: m.Signup })));
const SignupPlan = React.lazy(() => import('views/auth/signup/plan').then(m => ({ default: m.SignupPlan })));
const SignupUser = React.lazy(() => import('views/auth/signup/user').then(m => ({ default: m.SignupUser })));
const Signin = React.lazy(() => import('views/auth/signin').then(m => ({ default: m.Signin })));
const SigninOTP = React.lazy(() => import('views/auth/signin/otp').then(m => ({ default: m.SigninOTP })));
const SocialSignin = React.lazy(() => import('views/auth/signin/social').then(m => ({ default: m.SocialSignin })));
const ForgotPassword = React.lazy(() => import('views/auth/signin/forgotpassword').then(m => ({ default: m.ForgotPassword })));
const ResetPassword = React.lazy(() => import('views/auth/signin/resetpassword').then(m => ({ default: m.ResetPassword })));
const MagicSignin = React.lazy(() => import('views/auth/signin/magic').then(m => ({ default: m.MagicSignin })));
const ImpersonateSignin = React.lazy(() => import('views/auth/signin/impersonate').then(m => ({ default: m.ImpersonateSignin })));

const Routes = [
  {
    path: '/signup',
    view: NotFound,               //Signup,
    layout: 'auth',
    title: 'Registrarse'
  },
  {
    path: '/signup/plan',
    view: SignupPlan,
    layout: 'auth',
    permission: 'owner',
    title: 'Registrarse'
  },
  {
    path: '/signup/user',
    view: SignupUser,
    layout: 'auth',
    title: 'Registrarse'
  },
  {
    path: '/signin',
    view: Signin,
    layout: 'auth',
    title: 'TRS Administrador'
  },
  {
    path: '/signin/otp',
    view: SigninOTP,
    layout: 'auth',
    title: 'Ingresa el código de verificación'
  },
  {
    path: '/signin/social',
    view: SocialSignin,
    layout: 'auth',
    title: 'Completando inicio de sesión'
  },
  {
    path: '/magic',
    view: MagicSignin,
    layout: 'auth',
    title: 'Iniciar Sesión'
  },
  {
    path: '/forgotpassword',
    view: ForgotPassword,
    layout: 'home',
    title: 'Restablecer contraseña'
  },
  {
    path: '/resetpassword',
    view: ResetPassword,
    layout: 'home',
    title: 'Nueva contraseña'
  },
  {
    path: '/signin/impersonate',
    view: ImpersonateSignin,
    layout: 'auth',
    title: 'Iniciar sesión'
  },
]

export default Routes;
